var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquarePlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 5.625H3.375C2.96016 5.625 2.625 5.96016 2.625 6.375V20.625C2.625 21.0398 2.96016 21.375 3.375 21.375H17.625C18.0398 21.375 18.375 21.0398 18.375 20.625V6.375C18.375 5.96016 18.0398 5.625 17.625 5.625ZM16.6875 19.6875H4.3125V7.3125H16.6875V19.6875ZM20.625 2.625H6.1875C6.08437 2.625 6 2.70937 6 2.8125V4.125C6 4.22812 6.08437 4.3125 6.1875 4.3125H19.6875V17.8125C19.6875 17.9156 19.7719 18 19.875 18H21.1875C21.2906 18 21.375 17.9156 21.375 17.8125V3.375C21.375 2.96016 21.0398 2.625 20.625 2.625ZM7.03125 12.8906H13.9688V14.3906H7.03125V12.8906Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 5.625H3.375C2.96016 5.625 2.625 5.96016 2.625 6.375V20.625C2.625 21.0398 2.96016 21.375 3.375 21.375H17.625C18.0398 21.375 18.375 21.0398 18.375 20.625V6.375C18.375 5.96016 18.0398 5.625 17.625 5.625ZM16.6875 19.6875H4.3125V7.3125H16.6875V19.6875ZM20.625 2.625H6.1875C6.08437 2.625 6 2.70937 6 2.8125V4.125C6 4.22812 6.08437 4.3125 6.1875 4.3125H19.6875V17.8125C19.6875 17.9156 19.7719 18 19.875 18H21.1875C21.2906 18 21.375 17.9156 21.375 17.8125V3.375C21.375 2.96016 21.0398 2.625 20.625 2.625ZM7.03125 12.8906H13.9688V14.3906H7.03125V12.8906Z",
    fill: "#4F6FFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9688 12.8906H7.03125V14.3906H13.9688V12.8906Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9688 12.8906H7.03125V14.3906H13.9688V12.8906Z",
    fill: "#4F6FFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 17.1094L11.25 10.1719L9.75 10.1719L9.75 17.1094L11.25 17.1094Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 17.1094L11.25 10.1719L9.75 10.1719L9.75 17.1094L11.25 17.1094Z",
    fill: "#4F6FFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquarePlusIcon);
export default __webpack_public_path__ + "static/media/square-plus-icon.35d34f6c1da1eaf8a389a0b2b75e9d95.svg";
export { ForwardRef as ReactComponent };